export default (params) => ({
  trigger: {
    name: 'content_blocks.detailed_visual_entrances.view',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'main_category',
          'sub_category',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'view_content',
      params: {
        content: null,
      },
    },
    nonInt: true,
  },
});
